module.exports = __webpack_public_path__ + "img/nigeria.153cbb4e.png";